import branding from '../generated/branding.json';

export const API_BASE_URL = 'https://api.quickcheck.strata-host.co.uk';

const env = (name: string, fallback = ''): string => {
  const value = typeof process !== 'undefined' ? process.env[name] : undefined;
  return (value && value.trim()) || fallback;
};

type GeneratedBranding = {
  portalClientId?: string;
};

const entraClientId = String((branding as GeneratedBranding).portalClientId || '').trim();

/** Multi-tenant Entra SPA + API for customers and partner admins. Client id comes from site seed via branding. */
export const ENTRA_CONFIG = {
  CLIENT_ID: entraClientId,
  AUTHORITY: 'https://login.microsoftonline.com/organizations',
  API_SCOPE: entraClientId ? `api://${entraClientId}/access` : '',
} as const;

/**
 * Cognito Hosted UI client for Strata admins only (IAM Identity Center IdP).
 * Redirect must be /auth/strata/callback, not the Microsoft /auth/callback.
 */
export const STRATA_COGNITO_CONFIG = {
  CLIENT_ID: process.env.STRATA_COGNITO_CLIENT_ID || '',
  USER_POOL_ID: 'eu-west-2_9NN3lz5Iq',
  REGION: 'eu-west-2',
  DOMAIN: 'sso.quickcheck.strata-host.co.uk',
  IDP_NAME: process.env.STRATA_COGNITO_IDP_NAME || '',
} as const;

export interface CheckInputField {
  name: string;
  label: string;
  type: string;
  required?: boolean;
  placeholder?: string;
  pattern?: string;
}

export interface WizardStepConfig {
  id: string;
  name: string;
  kind: 'intro' | 'oauth' | 'registered' | 'logout' | 'complete';
  variant?: string;
  buttonLabel?: string;
}

export interface SiteCheck {
  taskDefId: string;
  authMode: 'delegated-immediate' | 'app-consent';
  datasourceType?: string;
  productLabel: string;
  title: string;
  body: string[];
  tooltip?: string;
  scopes?: string[];
  callbackPath?: string;
  offboardingPath?: string;
  wizardQueryParam?: string;
  wizardSteps?: WizardStepConfig[];
  inputSchema?: CheckInputField[];
  displayOrder: number;
  clientId?: string;
}

export interface SiteConfig {
  siteId: string;
  displayName: string;
  productName: string;
  supportEmail: string;
  legalEntity?: string;
  analytics?: { enabled: boolean; trackingId: string };
  branding?: { themeClass?: string; logoUrl?: string };
  checks: SiteCheck[];
}
